import queryString from 'query-string'
import apiV2 from '.'

export const categoriesApi = apiV2.injectEndpoints({
  endpoints: builder => ({
    addCategory: builder.mutation({
      query: ({ categoryId, conferenceId, companyId }) => ({
        url: `/categories/models`,
        method: 'POST',
        body: { categoryId, conferenceId, companyId },
      }),
      invalidatesTags: ['CATEGORIES_MODELS'],
    }),
    removeCategory: builder.mutation({
      query: ({ categoryId, conferenceId, companyId }) => ({
        url: `/categories/models`,
        method: 'DELETE',
        body: { categoryId, conferenceId, companyId },
      }),
      invalidatesTags: ['CATEGORIES_MODELS'],
    }),
    getCategories: builder.query({
      query: ({ eventId, companyId, conferenceId }) => `/categories?${queryString.stringify({ eventId, companyId, conferenceId })}`,
      transformResponse: response => response.data,
      providesTags: ['CATEGORIES_MODELS'],
    }),
  }),
})

export const { useGetCategoriesQuery, useAddCategoryMutation, useRemoveCategoryMutation } = categoriesApi
